import { theme } from "antd";
import ConfigProvider from "antd/lib/config-provider";
import Table from "antd/lib/table";
import classNames from "classnames";
import { CareerType } from "rivals/shared/interfaces/Career";
import { setData } from "rivals/shared/utils/qa";
import { getTableColumns } from "./columns";
import styles from "./index.module.scss";
import strings from "./strings";
import { EmptyTableProps, Props } from "./types";
import SearchIcon from "../Icons/SearchIcon";

const { noResults, noFilterResults, emptyList } = strings;
const TABLE_X_SCROLL_LIMIT = 960;

export const EmptyTableContent = ({
  peopleListIsFiltered
}: EmptyTableProps): JSX.Element => (
  <div className={styles.noResultsWrapper}>
    <div>
      <SearchIcon fill={styles["trout"]} />
      <span>{noResults}</span>
    </div>
    <div>{peopleListIsFiltered ? noFilterResults : emptyList}</div>
  </div>
);

const ListTable = ({ philter = "", people, filters }: Props): JSX.Element => {
  const token = theme.useToken();

  const peopleListIsFiltered =
    Object.values(filters).filter(filter => !!filter === true).length > 0;

  return (
    <ConfigProvider
      renderEmpty={(): JSX.Element => (
        <EmptyTableContent peopleListIsFiltered={peopleListIsFiltered} />
      )}
      theme={token}
    >
      <div className={styles.tableWrapper}>
        <Table
          className={classNames(styles.table, {
            [styles.emptyTable]: !people || !people.length
          })}
          columns={getTableColumns(CareerType.COLLEGE_PLAYER)}
          dataSource={people}
          key="people_table"
          pagination={false}
          rowKey="ordinality"
          scroll={{ x: TABLE_X_SCROLL_LIMIT }}
          {...setData(philter, "people-table")}
        />
      </div>
    </ConfigProvider>
  );
};

export default ListTable;
